// translations/pt.ts
import { TranslationKeys } from '../index';

export const pt: TranslationKeys = {
  header: {
    tutorialButton: "Tutoriais",
    currentLanguage: "Atual"
  },
  hero: {
    title: "Jogue Sudoku Vs Agora!",
    description: "Prepare-se para um desafio de Sudoku como nenhum outro! Desfrute da prática a solo ou enfrente amigos — baixe agora e sinta a emoção!",
    howToPlay: "Como Jogar",
    googlePlay: {
      topText: "Disponível no",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "Baixar na",
      bottomText: "App Store"
    },
    botButtonShow: "Precisa de ajuda? Pergunte ao nosso Bot!",
    botButtonHide: "Ocultar Assistente"
  },
  footer: {
    followUs: "SIGA-NOS EM",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 Sudoku VS. Todos os direitos reservados."
  },
  beginnersGuide: {
    modalTitle: "GUIA PARA INICIANTES",
    originsTab: "ORIGENS DO SUDOKU",
    basicsTab: "BÁSICOS DO SUDOKU",
    rulesTab: "REGRAS DO JOGO VS",
    origins: {
      bulletOne: "Inspirado nos quadrados latinos; publicado pela primeira vez em 1979 por Howard Garns.",
      bulletTwo: "Tornou-se popular no Japão nos anos 80, renomeado para “Sudoku”. Ganhou fama global nos anos 2000.",
      bulletThree: "Grelha 9x9 com nove sub-grelhas 3x3; preencha com números de 1 a 9 sem repetições em linhas, colunas ou sub-grelhas.",
      bulletFour: "Amado por milhões, com muitas variações e novos desafios.",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "Preencha o número que falta!",
      correct: "CORRETO!",
      incorrect: "INCORRETO",
      instructions: "Complete o quebra-cabeça 3X3 inserindo o número correto no espaço destacado. Cada linha, coluna e caixa deve conter cada número exatamente uma vez. Selecione o número correto. Escolha com sabedoria!",
      feedbackCorrect: "VOCÊ RESOLVEU SUA PRIMEIRA CAIXA!",
      feedbackIncorrect: "TENTE NOVAMENTE!",
      basicsStep2: {
        instructions: "Complete o quebra-cabeça 4X4 selecionando o número correto para o espaço destacado. Cada linha, coluna e caixa deve conter cada número exatamente uma vez. Selecione o número correto. Escolha com sabedoria!",
        feedbackCorrect: "VOCÊ ESTÁ COM SORTE!"
      },
      basicsStep3: {
        instructions: "Complete o quebra-cabeça 4X4 selecionando o número correto para o espaço destacado. Cada linha, coluna e caixa deve conter cada número exatamente uma vez. Selecione o número correto. Escolha com sabedoria!",
        feedbackCorrect: "SOLUÇÃO PERFEITA!",
        feedbackIncorrect: "INCORRETO - TENTE NOVAMENTE!"
      },
      congratulations: {
        title: "Parabéns!",
        subtitle: "Você completou com sucesso o tutorial de noções básicas de Sudoku! Sua dedicação e esforço valeram a pena, e agora você está equipado com as habilidades essenciais para enfrentar os quebra-cabeças de Sudoku com confiança.",
        nextStepsTitle: "Próximos Passos",
        nextStepsText: "Agora é hora de testar suas habilidades! Baixe o jogo de Sudoku hoje e mergulhe em uma variedade de quebra-cabeças. Se você prefere um jogo rápido a solo ou quer participar de uma competição amigável, pode escolher jogar no modo single ou no modo vs contra um oponente.",
        ctaHeader: "Pronto para um jogo?",
        ctaHighlight: "Baixe Agora!",
        rulesTitle: "Domine as Regras do Jogo",
        rulesText: "Antes de começar, certifique-se de verificar as Regras do Jogo de Sudoku VS. Entender as regras e o sistema de pontuação pode lhe dar uma vantagem ao jogar contra oponentes. Este conhecimento irá aprimorar sua experiência e ajudá-lo a criar estratégias eficazes!"
      }
    },
    gameRules: {
      notification: {
        important: "Importante: ",
        text: "Ative as notificações para a melhor experiência!"
      },
      rulesHeader: "Regras",
      rulesList: {
        rule1_pre: "Aceite ou crie um convite para uma ",
        rule1_strong: "partida amigável ou aleatória",
        rule1_post: ".",
        rule2_pre: "Um jogador é ",
        rule2_strong: "selecionado aleatoriamente para começar.",
        rule3: "Os jogadores se revezam até que o tabuleiro esteja completo.",
        rule4_pre1: "Cada ",
        rule4_strong1: "turno dura 60 segundos,",
        rule4_pre2: " com um limite de ",
        rule4_strong2: "5 números por turno.",
        rule5_pre: "Apenas ",
        rule5_strong: "1 dica",
        rule5_post: " é permitida por turno.",
        rule6_pre: "O jogador com ",
        rule6_strong: "a maior pontuação vence",
        rule6_post: " o jogo.",
        rule7_pre: "Em caso de ",
        rule7_strong_pre: "empate",
        rule7_pre2: ", o jogador com mais entradas ",
        rule7_strong_post: "vence",
        rule7_post: " o jogo.",
        rule8: "Se você não terminar seu turno em 24 horas, você perde automaticamente o jogo."
      },
      rulesWarning: "Jogue seu turno em 24 horas ou você perderá o jogo automaticamente",
      gameControls: {
        header: "Controles do Jogo",
        list: {
          control1_pre: "Use a ",
          control1_strong: "Bandeira de Desistência",
          control1_post: " para desistir do jogo.",
          control2_pre: "Use a ",
          control2_strong: "Borracha",
          control2_post: " para corrigir um erro.",
          control3_pre: "Use ",
          control3_strong: "Finalizar Turno",
          control3_post: " se você completou todas as suas entradas antes que o tempo acabe."
        }
      },
      scoring: {
        header: "Pontuação",
        list: {
          score1_pre1: "Ganhe ",
          score1_strong1: "1 ponto",
          score1_pre2: " por colocação de número ",
          score1_span: "correta",
          score1_post: ".",
          score2_pre1: "Perca ",
          score2_strong1: "1 ponto",
          score2_pre2: " por cada colocação de número ",
          score2_span: "incorreta",
          score2_post: ".",
          score3_pre1: "Ganhe ",
          score3_strong1: "5 pontos",
          score3_pre2: " por cada linha, coluna e caixa ",
          score3_span: "resolvida",
          score3_post: "."
        }
      },
    },
    controller: {
      previous: "Anterior",
      of: " de ",
      close: "Fechar",
      next: "Próximo",
      gameRules: "Regras do Jogo",
    },
  },
  tutorials: {
    modalTitle: "Tutoriais",
    tabs: {
      introduction: "Introdução",
      gettingStarted: "Começando",
      vsFriends: "Contra Amigos",
      howToPlay: "Como Jogar",
    },
    messages: {
      loading: "Carregando tutoriais...",
      error: "Erro ao carregar tutoriais:",
      fallback: "Usando dados de fallback...",
      empty: "Nenhum tutorial disponível para esta seção.",
    },
  },
  cookieConsent: {
    title: "Gerenciar Preferências de Consentimento",
    description: "Usamos cookies para aprimorar sua experiência no Sudoku VS, analisar nosso tráfego e fornecer anúncios personalizados.",
    acceptAll: "Aceitar Todos os Cookies",
    confirmChoices: "Confirmar Escolhas",
    performance: {
      title: "Cookies de Desempenho",
      description: "Permite-nos coletar dados para melhorar nosso jogo e serviços através da análise de uso."
    },
    advertising: {
      title: "Publicidade",
      adStorage: "Permite o armazenamento de dados de publicidade no seu dispositivo",
      adMeasurement: "Permite a coleta de dados para medição de publicidade",
      adPersonalization: "Permite-nos mostrar anúncios personalizados com base nos seus interesses"
    },
    landing: {
        title: "Aviso de Cookies",
        description: "Usamos cookies para aprimorar sua experiência no Sudoku VS, analisar nosso tráfego e fornecer anúncios personalizados. Você pode definir quais cookies deseja permitir antes de continuar.",
        acceptAll: "Aceitar todos os Cookies",
        customizeSettings: "Personalizar Configurações",
        fineprint: "Ao clicar em \"aceitar todos os cookies\", você concorda que<br />o Sudoku VS pode armazenar cookies no seu dispositivo"
    }
  },

    privacyPolicy: {
    modalTitle: "Política de Privacidade",
    sections: {
      introduction: {
        title: "1. Introdução",
        p1: "Bem-vindo ao Sudoku VS. Estamos comprometidos em proteger sua privacidade e garantir que você tenha uma experiência positiva em nosso site. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações quando você usa nossa plataforma de jogo Sudoku.",
        p2: "Ao usar o Sudoku VS, você concorda com a coleta e uso de informações de acordo com esta política."
      },
      informationWeCollect: {
        title: "2. Informações que Coletamos",
        p1: "Coletamos diferentes tipos de informações para fornecer e melhorar nossos serviços:",
        list: {
          usageData: "Dados de Uso: Coletamos automaticamente informações sobre como você interage com nosso jogo, incluindo estatísticas de jogo, tempos de conclusão de quebra-cabeças, níveis de dificuldade jogados e preferências de jogo.",
          deviceInfo: "Informações do Dispositivo: Podemos coletar informações sobre o dispositivo que você usa para acessar o Sudoku VS, incluindo tipo de dispositivo, tipo de navegador, endereço IP e sistema operacional.",
          cookies: "Cookies e Dados de Rastreamento: Usamos cookies e tecnologias de rastreamento semelhantes para melhorar sua experiência e coletar dados analíticos."
        }
      },
      howWeUseInfo: {
        title: "3. Como Usamos suas Informações",
        p1: "Usamos as informações coletadas para os seguintes propósitos:",
        list: {
          gameImprovement: "Melhoria do Jogo: Para analisar padrões de jogo e melhorar nossos quebra-cabeças Sudoku, algoritmos de dificuldade e a experiência geral do usuário.",
          performanceAnalytics: "Análise de Desempenho: Para monitorar e analisar tendências de uso, medir a eficácia de nossos serviços e identificar áreas de melhoria.",
          personalization: "Personalização: Para fornecer recomendações de jogo personalizadas e conteúdo adaptado com base em suas preferências de jogo.",
          technicalSupport: "Suporte Técnico: Para solucionar problemas, corrigir bugs e garantir a operação suave de nossa plataforma."
        }
      },
      cookies: {
        title: "4. Cookies e Tecnologias de Rastreamento",
        p1: "O Sudoku VS usa cookies para melhorar sua experiência. Você tem a opção de gerenciar suas preferências de cookies:",
        performanceCookies: {
          title: "Cookies de Desempenho:",
          description: "Estes cookies nos permitem coletar dados para melhorar nosso jogo e serviços através da análise de uso. Eles nos ajudam a entender como os jogadores interagem com nossos quebra-cabeças, quais recursos são mais populares e onde podemos fazer melhorias. Esses dados são essenciais para melhorar a jogabilidade e criar melhores experiências Sudoku."
        },
        advertisingCookies: {
          title: "Cookies de Publicidade:",
          list: [
            "Permitem o armazenamento de dados publicitários em seu dispositivo",
            "Permitem a coleta de dados para medição e eficácia da publicidade",
            "Nos permitem mostrar anúncios personalizados com base em seus interesses e comportamento de jogo"
          ]
        },
        p2: "Você pode controlar suas preferências de cookies através do banner de consentimento de cookies que aparece quando você visita nosso site pela primeira vez. Você pode alterar suas configurações a qualquer momento através das configurações do seu navegador, embora desativar certos cookies possa afetar a funcionalidade do site."
      },
      thirdParty: {
        title: "5. Serviços de Terceiros",
        p1: "O Sudoku VS integra com os seguintes serviços de terceiros:",
        gemini: {
          title: "Assistente de IA Google Gemini:",
          description: "Nosso bot de ajuda é alimentado pelo Google Gemini com uma base de conhecimento integrada para ajudá-lo com perguntas relacionadas ao jogo, fornecer dicas de Sudoku e ajudar a solucionar problemas. Quando você interage com o bot, suas consultas podem ser processadas pelos sistemas do Google. Consulte a Política de Privacidade do Google para obter informações sobre como eles lidam com os dados."
        },
        youtube: {
          title: "Vídeos Incorporados do YouTube:",
          description: "Usamos sobreposições de vídeo do YouTube para fornecer conteúdo tutorial e guias de jogo diretamente em nosso site. Quando você interage com esses vídeos, o YouTube pode coletar dados de acordo com sua política de privacidade. Você pode assistir vídeos sem sair do Sudoku VS, mas os mecanismos de rastreamento do YouTube ainda podem se aplicar."
        },
        advertising: {
          title: "Parceiros de Publicidade:",
          description: "Trabalhamos com parceiros de publicidade terceiros para exibir anúncios em nossa plataforma. Esses parceiros podem usar cookies e tecnologias semelhantes para coletar informações sobre sua atividade de navegação para fins de publicidade personalizada."
        }
      },
      dataSecurity: {
        title: "6. Segurança de Dados",
        p1: "Levamos a segurança de seus dados a sério e implementamos medidas técnicas e organizacionais apropriadas para proteger suas informações contra acesso, alteração, divulgação ou destruição não autorizados. No entanto, observe que nenhum método de transmissão pela Internet ou armazenamento eletrônico é 100% seguro.",
        p2: "Nosso site usa protocolos de segurança padrão do setor e é verificado pelo selo de segurança GoDaddy para garantir uma experiência de navegação segura."
      },
      privacyRights: {
        title: "7. Seus Direitos de Privacidade",
        p1: "Você tem certos direitos em relação às suas informações pessoais:",
        list: {
          access: "Acesso: Você pode solicitar informações sobre os dados que mantemos sobre você",
          correction: "Correção: Você pode solicitar a correção de informações imprecisas",
          deletion: "Exclusão: Você pode solicitar a exclusão de seus dados, sujeito a obrigações legais",
          optOut: "Opt-out: Você pode optar por não receber publicidade personalizada através de suas preferências de cookies",
          portability: "Portabilidade de Dados: Você pode solicitar uma cópia de seus dados em um formato portátil"
        }
      },
      childrenPrivacy: {
        title: "8. Privacidade Infantil",
        p1: "O Sudoku VS é projetado para o público em geral. Não coletamos intencionalmente informações pessoais de crianças menores de 13 anos. Se você é pai ou responsável e acredita que seu filho nos forneceu informações pessoais, entre em contato conosco para que possamos tomar as medidas apropriadas."
      },
      changes: {
        title: "9. Alterações nesta Política de Privacidade",
        p1: "Podemos atualizar esta Política de Privacidade periodicamente para refletir mudanças em nossas práticas ou por razões legais, operacionais ou regulatórias. Notificaremos você sobre quaisquer alterações materiais publicando a nova Política de Privacidade nesta página e atualizando a data da \"Última Atualização\" abaixo.",
        p2: "Incentivamos você a revisar esta Política de Privacidade periodicamente para se manter informado sobre como protegemos suas informações."
      },
      contact: {
        title: "10. Entre em Contato",
        p1: "Se você tiver alguma dúvida, preocupação ou solicitação em relação a esta Política de Privacidade ou nossas práticas de dados, entre em contato conosco:",
        email: "E-mail: privacy@sudoku.vs",
        website: "Site: www.sudoku.vs",
        p2: "Responderemos sua consulta o mais breve possível."
      }
    },
    footer: {
      lastUpdated: "Última atualização: 10 de outubro de 2025",
      effectiveDate: "Data de efetivação: 10 de outubro de 2025"
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},
  copywright: {
    text: 'Copyright © 2025 Software Architects Ltd. Todos os direitos reservados.'
  }
};